import { render, staticRenderFns } from "./FieldEditVersionsVersion.vue?vue&type=template&id=09e29888&"
import script from "./FieldEditVersionsVersion.vue?vue&type=script&lang=js&"
export * from "./FieldEditVersionsVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports